const { getItemColumns } = require('./item-dt-handler');
const websocket = require('../../../../../js-network/web-socket');

// El callback de guardado solo comunica el documento que cambio.
export function notifySavedInventory(sourceEntity, data, result) {
    const wasSaved = result?.status === 'ok' && data?.id;
    const hasRestriction = result?.restriction && result.restriction.val !== 'ok';

    if (!wasSaved || hasRestriction || !['sale', 'purchase'].includes(sourceEntity)) return;

    const params = {
        sourceEntity,
        sourceId: String(data.id)
    };

    websocket.send({
        act: 'entityUpdate',
        data: {
            entityCall: {
                entity: 'item',
                elem: 'dt',
                function: 'refreshInventory',
                params
            },
            sendDetail: { to: 'allStaff', from: 'staffDesktop', id: '' }
        }
    });

    // El servidor no reenvia el mensaje a quien guarda.
    require('./item-dt').start({ ...params, act: 'refreshInventory' });
}

// Depura la respuesta: solo acepta filas de los IDs afectados y elimina duplicados.
function cleanInventory(inventory) {
    if (!Array.isArray(inventory?.itemIds) || !Array.isArray(inventory.rows)) return null;

    const itemIds = new Set(inventory.itemIds.map(String).filter(id => /^[1-9]\d*$/.test(id)));
    const rowsByItemAndUnit = new Map();
    inventory.rows.forEach(row => {
        if (!row || !itemIds.has(String(row.id))) return;
        rowsByItemAndUnit.set(String(row.id) + ':' + String(row.item_unit_id), row);
    });

    return { itemIds: Array.from(itemIds), rows: Array.from(rowsByItemAndUnit.values()) };
}

export async function applyInventoryChanges(detail, htmlDt) {
    if (!htmlDt.entityDt?.isConnected || !['sale', 'purchase'].includes(detail?.sourceEntity)) return;
    if (!/^[1-9]\d*$/.test(String(detail.sourceId))) return;

    // Como en el WebSocket del framework, solo trabajamos con un DT existente.
    const currentBody = htmlDt.dtBody;
    // Peticion en segundo plano: no activa la animacion global de carga.
    const body = new FormData();
    body.append('entity', 'item');
    body.append('sourceEntity', detail.sourceEntity);
    body.append('sourceId', detail.sourceId);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    let result;
    try {
        const response = await fetch('./server/php/queries/entityFunction/item-inventoryResponse.php', {
            method: 'POST',
            body,
            credentials: 'same-origin',
            signal: controller.signal
        });
        if (!response.ok) return;
        result = await response.json();
        if (result?.authentication?.val !== 'ok' || result?.authorization?.val !== 'ok' ||
            result?.error?.val !== 'ok' || result?.restriction?.val !== 'ok') return;
    } catch (error) {
        console.warn('Item: no se pudo actualizar el inventario.', error);
        return;
    } finally {
        clearTimeout(timeout);
    }

    // El usuario pudo cerrar o volver a crear el DT mientras llegaba la respuesta.
    if (!currentBody.isConnected || htmlDt.dtBody !== currentBody) return;
    const inventory = cleanInventory({ itemIds: result.extrainfo?.itemIds, rows: result.data });
    if (!inventory) return;

    inventory.itemIds.forEach(itemId => {
        const rows = inventory.rows.filter(row => String(row.id) === itemId);
        updateItemRows(itemId, rows, htmlDt);
    });
    return true;
}

function getUnitId(row) {
    try {
        return String(JSON.parse(row.getAttribute('data-item')).item_unit_id);
    } catch (error) {
        return '';
    }
}

function updateItemRows(itemId, rows, htmlDt) {
    // El ID del TR se repite: la unidad en data-item identifica cada combinacion.
    const rowsByUnit = new Map(rows.map(row => [String(row.item_unit_id), row]));
    const visibleRows = htmlDt.dtBody.querySelectorAll('[id="item-tableRow-' + itemId + '"]');

    visibleRows.forEach(tableRow => {
        const item = rowsByUnit.get(getUnitId(tableRow));
        if (!item) return;
        updateRowCells(tableRow, item);
    });
}

function updateRowCells(tableRow, item) {
    // Mismo orden que organizeRow de Item. La celda 0 contiene el checkbox.
    const columns = getItemColumns(item);
    let hasChanges = false;

    columns.forEach((column, index) => {
        const cell = tableRow.cells[index + 1];
        if (!cell) return;
        const labelChanged = updateCellText(cell.querySelector('label'), column.label);
        const spanChanged = updateCellText(cell.querySelector('span'), column.span);
        if (labelChanged || spanChanged) hasChanges = true;
    });

    // Conserva los datos que usa el menu de la fila para esta unidad.
    tableRow.setAttribute('data-item', JSON.stringify({
        item_name: item.name,
        item_unit_id: item.item_unit_id,
        item_unit_name: item.item_unit_name
    }));
    if (hasChanges) highlightUpdatedRow(tableRow);
}

function updateCellText(element, value) {
    if (!element) return false;
    const text = String(value ?? '');
    if (element.textContent.trim() === text.trim()) return false;
    element.textContent = text;
    return true;
}

const highlightTimers = new WeakMap();

function highlightUpdatedRow(tableRow) {
    // Misma clase y duracion que shakeTr del framework, sobre el TR exacto.
    clearTimeout(highlightTimers.get(tableRow));
    tableRow.classList.remove('tr-notice');
    void tableRow.offsetWidth; // Reinicia la animacion si llega otro cambio seguido.
    tableRow.classList.add('tr-notice');
    highlightTimers.set(tableRow, setTimeout(() => {
        tableRow.classList.remove('tr-notice');
        highlightTimers.delete(tableRow);
    }, 600));
}
